import { render, staticRenderFns } from "./LmReportsBuilder.vue?vue&type=template&id=5b4b0646&"
import script from "./LmReportsBuilder.vue?vue&type=script&lang=js&"
export * from "./LmReportsBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports